export default function ServicesHero() {
  return (
    <section id="top" className="relative min-h-[560px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20teal%20data%20center%20corridor%20with%20glowing%20server%20racks%20and%20soft%20green%20teal%20light%20streaks%2C%20minimal%20modern%20enterprise%20computing%20atmosphere%2C%20clean%20geometric%20perspective%20lines%2C%20cinematic%20wide%20composition%20with%20deep%20navy%20shadows%20suitable%20for%20professional%20IT%20infrastructure%20services%20header&width=1800&height=900&seq=acu-services-hero-01&orientation=landscape"
        className="absolute inset-0 w-full h-full object-cover object-top"
        alt="Acu-Comp enterprise infrastructure services"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950/90 via-primary-900/75 to-primary-950/90"></div>
      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8 pt-32 pb-20">
        <nav className="flex items-center gap-2 text-xs text-background-100/70 mb-6">
          <a href="/" className="cursor-pointer hover:text-accent-500">Home</a>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Services</span>
        </nav>
        <span className="inline-flex items-center gap-2 bg-background-50/10 border border-background-50/20 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium mb-6">
          <i className="ri-flashlight-line"></i> Full-stack IT services for growing businesses
        </span>
        <h1 className="text-4xl md:text-6xl font-bold text-background-50 leading-tight max-w-3xl">
          Enterprise infrastructure, sized for your business.
        </h1>
        <p className="mt-6 text-lg text-background-100/90 max-w-2xl">
          From IBM Power and enterprise storage to virtualization, cloud, and security, Acu-Comp designs,
          deploys, and supports the systems that keep North American businesses running.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="#offerings"
            className="bg-accent-500 hover:bg-accent-600 text-foreground-950 font-semibold px-8 py-4 rounded-md whitespace-nowrap cursor-pointer transition inline-flex items-center gap-2"
          >
            Browse Our Services <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="/#contact"
            className="border border-background-50/40 text-background-50 hover:bg-background-50/10 font-semibold px-8 py-4 rounded-md whitespace-nowrap cursor-pointer transition"
          >
            Talk to an Engineer
          </a>
        </div>
      </div>
    </section>
  );
}